import React, { createContext, useState } from "react";

export const CritereFiltreContext = createContext();

export const CritereFiltreProvider = ({ children }) => {
  const [critereFiltre, setCritereFiltre] = useState("Tous les messages");
  const [searchText, setSearchText] = useState("");
  return (
    <CritereFiltreContext.Provider value={{ critereFiltre, setCritereFiltre, searchText, setSearchText }}>
      {children}
    </CritereFiltreContext.Provider>
  );
};
